import { Component, HostListener } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';

import { CoreProvider } from './../../providers/core-service/core-service';
import { NetworkConnectionProvider } from './../../providers/network-connection/network-connection';

import { Week } from '../../model/Week';
import { User } from '../../model/User';
import { Subscription } from 'rxjs/Subscription';

import { DatePipe } from '@angular/common';
import { AlertController } from 'ionic-angular/components/alert/alert-controller';
import { ModalEditPage } from '../modal-edit/modal-edit';
import { legendaStati } from '../../constants/constants';
import { Messages } from '../../constants/messages';

/**
 * Generated class for the WebWeeklyViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-web-weekly-view',
  templateUrl: 'web-weekly-view.html',
})
export class WebWeeklyViewPage {

  show_loading: boolean = true;
  labelWeek = 'Week';

  showNav = false; //on tablet

  user = {
    name: '',
    title: '',
    photo: '',
    role: 'delegate'
  };

  showMessage = false;
  onlyHR = false;

  overNoteUser = '';
  overNoteIndex = '';

  showPopover = false;
  popover = {
    index: '',
    open: false,
    travel: false,
    day: '',
    day_text: '',
    halfday: '',
    halfday_note: '',
    halfday_note_show: false,
    userkey: '',
    week: {},
    showEdit: false
  }

  week_days: Array<string> = [];

  onlyLeaveTravel = false;

  selected_week_userkey = '';
  selected_week_element = [];

  week_range: [Date, Date];
  week_differ: number = 0;
  week_binding: Week[] = [];

  weeksbinding: Subscription;

  private index_list: string[] = ['1_am', '1_pm', '2_am', '2_pm', '3_am', '3_pm',
    '4_am', '4_pm', '5_am', '5_pm', '6_am', '6_pm', '7_am', '7_pm']; //indice per settimana in ricerca

  prevShow: boolean = true;
  nextShow: boolean = true;

  userListToShow: User[] = [];

  private onNext = true;
  private onPrev = true;
  private checkNextOnce = false;
  private checkPrevOnce = false;

  showAutocomplete = false;
  showTravelEvidence = false;
  querySearch = '';
  autocomplete = [];
  manager = [];
  places = [];

  pageActive = 'week';

  resultsEmpty: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public network: NetworkConnectionProvider,
    private coreService: CoreProvider,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController
  ) {
    this.week_range = this.coreService.getWeekRange();
    this.week_days = this.defineWeekDays();
  }

  @HostListener('document:keyup', ['$event'])
  onKeyUp(ev: KeyboardEvent) {
    // do something meaningful with it
    if (this.showPopover) {
      if (ev.which == 27)
        this.closeNote();
    }
    // console.log(`The user just pressed ${ev.key}!`);
  }

  ionViewWillEnter() {

    this.coreService.getUserData().filter(x => x).subscribe(user => {
      //console.log('autenticato: ' + user.key);
      //console.log(user);

      if (user) {
        this.user = user;

        if (this.user.role == 'hr') {
          this.onlyHR = true;
        }
      }
    });

    let resetDate = this.navParams.get('resetDate');

    if (resetDate) {
      this.coreService.setSearchedData(null);
      this.coreService.resetWeekPointer(true);
    }

    let leaveTravel = this.navParams.get('leaveTravel');

    this.pageActive = 'week';
    if (leaveTravel) {
      this.onlyLeaveTravel = leaveTravel;

      this.pageActive = 'weekt';
    }

    //this.week_range = firebase.getWeekRange();

    this.weeksbinding = this.coreService.getWeek().subscribe(week => {
      if (this.coreService.getWeekDiffer() == 0) {
        this.labelWeek = 'Current Week';
      } else if (this.coreService.getWeekDiffer() < 0) {
        this.labelWeek = '' + this.coreService.getWeekDiffer() + ' Week';
      } else if (this.coreService.getWeekDiffer() > 0) {
        this.labelWeek = '+' + this.coreService.getWeekDiffer() + ' Week';
      }

      this.week_binding = week;

      if (this.onlyLeaveTravel)
        this.purgeWeek();

      if (this.week_binding.length == 0)
        this.showMessage = true;
      else {
        this.showMessage = false;
      }

      this.week_range = this.coreService.getWeekRange();
      this.week_days = this.defineWeekDays();

      if (this.onNext && !this.checkNextOnce) {
        this.checkNextOnce = true;
        this.coreService.getofflineNextBlock().then(result => {
          this.nextShow = result;
          //console.log(result);
        });
      }


      if (this.onPrev && !this.checkPrevOnce) {
        this.checkPrevOnce = true;
        //console.log('heck prev');
        this.coreService.getofflinePrevBlock().then(result => {
          //console.log(result);
          this.prevShow = result;
        });
      }

      this.mantainResearch();

    });

  }

  ionViewWillLeave() {
    // enable the root left menu when leaving this page
    this.weeksbinding.unsubscribe();
  }

  loadActual() {
    this.coreService.getActualWeek();

    this.coreService.getofflineNextBlock().then(result => {
      this.nextShow = result;
    });

    this.coreService.getofflinePrevBlock().then(result => {
      this.prevShow = result;
    });
  }

  showNavBar() {
    this.showNav = true;
  }

  closeNav() {
    this.showNav = false;
  }

  /**
   * Purge week elimina gli utenti non in leave o travel nella settimana
   */
  purgeWeek() {
    let purgedWeek = [];
    let weeks = this.week_binding;

    if (this.coreService.userData == 'ad') { //rimuove primo elemento se AD in leaveTravel
      weeks.shift();
    }

    for (let week of this.week_binding) {
      //console.log(week);
      for (let index of this.index_list) {
        if (week[index]) {
          if (legendaStati.indexOf(week[index]) == -1) {
            purgedWeek.push(week);
            break;
          }
        }
      }
    }

    this.week_binding = purgedWeek;
  }

  /**
   * Visualizza lo stato della settimana
   * @param key indice utente
   */
  checkUserPermission(key: string): boolean {

    if (this.onlyLeaveTravel) return false;

    if (this.coreService.userData.role == "hr") return true;

    if (this.coreService.userKey == key) return true;

    if (this.coreService.userData.delegations && this.coreService.userData.delegations.indexOf(key) > -1) return true;

    return false;
  }

  /**
   * Visualizza lo stato della settimana
   * @param key indice utente
   */
  checkUserViewConfirm(key: string): boolean {

    if (this.coreService.userData.role == "hr") return true;

    if (this.coreService.userKey == key) return true;

    if (this.coreService.userData.delegations && this.coreService.userData.delegations.indexOf(key) > -1) return true;

    return false;
  }

  /**
   * Controlla le selezioni nei casi speciali
   * @param type 0 = single day, 1 = am, 2 = pm
   */
  checkSpecialElement(userkey: string, type: number, day_number?: number) {

    if (userkey != this.selected_week_userkey) return false;
    if (this.selected_week_element.length == 0) return false;

    if (type == 0) {
      let day = [day_number + '_am', day_number + '_pm'];
      if (this.selected_week_element.indexOf(day[0]) > -1 && this.selected_week_element.indexOf(day[1]) > -1) {
        return true;
      }
    } else if (type == 1) {
      let days = ['1_am', '2_am', '3_am', '4_am', '5_am', '6_am', '7_am'];
      let counter = 0;
      for (const key of days) {
        if (this.selected_week_element.indexOf(key) > -1) {
          counter = counter + 1;
        }
      }
      if (counter == 7) {
        return true;
      }
    } else if (type == 2) {
      let days = ['1_pm', '2_pm', '3_pm', '4_pm', '5_pm', '6_pm', '7_pm'];
      let counter = 0;
      for (const key of days) {
        if (this.selected_week_element.indexOf(key) > -1) {
          counter = counter + 1;
        }
      }
      if (counter == 7) {
        return true;
      }
    }

    return false;
  }

  /**
   * Controlla a selezione della cella
   * @param key indice cella
   */
  checkElement(userkey: string, key: string): boolean {

    if (userkey != this.selected_week_userkey) return false;

    if (this.selected_week_element.length == 0) return false;

    if (this.selected_week_element.indexOf(key) > -1)
      return true;

    return false;
  }

  /**
   * Controlla viene selezionata una cella dell'utente
   * @param userkey 
   */
  checkUser(userkey: string): boolean {

    if (this.onlyLeaveTravel) return false;

    if (userkey == this.selected_week_userkey && this.selected_week_element.length == 1) return true;

    return false;
  }

  /**
   * Inserisce i giorni nei casi speciali
   * @param type 0 = single day, 1 = am, 2 = pm
   */
  toggleSpecialSelectedElement(userkey: string, type: number, day_number?: number): void {

    if (!this.checkUserPermission(userkey)) return;

    if (userkey != this.selected_week_userkey) {
      this.selected_week_element = [];
      this.selected_week_userkey = userkey;
    }

    if (type == 0) {
      let day = [day_number + '_am', day_number + '_pm'];
      if (this.selected_week_element.indexOf(day[0]) > -1 && this.selected_week_element.indexOf(day[1]) > -1) {
        this.removeArrayElement(day[0]);
        this.removeArrayElement(day[1]);
      } else {
        if (this.selected_week_element.indexOf(day[0]) == -1) {
          this.selected_week_element.push(day[0]);
        }
        if (this.selected_week_element.indexOf(day[1]) == -1) {
          this.selected_week_element.push(day[1]);
        }
      }
    } else if (type == 1) {
      let days = ['1_am', '2_am', '3_am', '4_am', '5_am', '6_am', '7_am'];
      let counter = 0;
      for (const key of days) {
        if (this.selected_week_element.indexOf(key) > -1) {
          counter = counter + 1;
        }
      }
      if (counter == 7) {
        for (const key of days) {
          this.removeArrayElement(key);
        }
      } else {
        for (const key of days) {
          if (this.selected_week_element.indexOf(key) == -1) {
            this.selected_week_element.push(key);
          }
        }
      }
    } else if (type == 2) {
      let days = ['1_pm', '2_pm', '3_pm', '4_pm', '5_pm', '6_pm', '7_pm'];
      let counter = 0;
      for (const key of days) {
        if (this.selected_week_element.indexOf(key) > -1) {
          counter = counter + 1;
        }
      }
      if (counter == 7) {
        for (const key of days) {
          this.removeArrayElement(key);
        }
      } else {
        for (const key of days) {
          if (this.selected_week_element.indexOf(key) == -1) {
            this.selected_week_element.push(key);
          }
        }
      }
    }
  }

  toggleSelectedElement(userkey: string, element: string, week_confirmed: boolean): void {

    //if (week_confirmed) return;
    
    if (this.onlyLeaveTravel) return;
    //if (!this.checkUserPermission(userkey)) return;

    let newArray: string[] = [];
    let present = false;

    if (userkey != this.selected_week_userkey) {
      this.selected_week_element = [];
      this.selected_week_userkey = userkey;
    }

    for (const key of this.selected_week_element) {
      if (key == element)
        present = true;
      else
        newArray.push(key);
    }

    if (!present)
      newArray.push(element);

    this.selected_week_element = newArray;
  }

  countSelected(): number {
    return this.selected_week_element.length;
  }

  removeArrayElement(element: string): void {
    let newArray: string[] = [];
    for (const key of this.selected_week_element) {
      if (key != element)
        newArray.push(key);
    }

    this.selected_week_element = newArray;
  }

  confirmWeek(userkey: string) {

    let alert = this.alertCtrl.create({
      title: "<b>" + Messages.week_confirm + "</b><br><br>" + Messages.hr_confirm,
      cssClass: 'alert-week',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'OK',
          handler: () => {
            this.coreService.confirmWeek(userkey);
          }
        }
      ]
    });
    alert.present();

  }

  unlockWeek(userkey: string) {
    let alert = this.alertCtrl.create({
      title: 'Unlock Week',
      cssClass: 'alert-week',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'OK',
          handler: () => {
            this.coreService.unlockWeek(userkey);
          }
        }
      ]
    });
    alert.present();

  }

  getName(key: string): string {

    for (let i of this.coreService.getListUsers()) {
      if (i.key == key) {
        return i.name;
      }
    }
    return key;

  }

  /**
   * Funzione autocompletamento
   * @param query stringa ricercata
   * {"autocomplete": ["Marcat Siro"], "managers": {"Marcat Siro": "year/2018/6/siromarcat@gmailcom"}, "places": {}}
   * {"autocomplete": ["Padua", "Padova"], "managers": {}, "places": {"Padua": ["year/2018/6/ggiorgianni@demogoreplyio/1_am"], "Padova": ["year/2018/6/ggiorgianni@demogoreplyio/1_am"]}}
   */
  onChange(query: string) {
    if (query.length > 2) {

      this.coreService.getAutocompleteSearchValues(query).first().subscribe(result => {

        this.showAutocomplete = true;
        this.autocomplete = result.autocomplete;

        this.manager = result.managers;
        this.places = result.places;
      });

    } else {
      this.showAutocomplete = false;
      this.autocomplete = [];

      this.manager = [];
      this.places = [];
    }
  }

  /**
   * Controlla se la ricerca è attiva
   */
  isQuerying(): boolean {
    if (this.querySearch.length > 0) {
      return true;
    }

    //this.searchedPlace = '';
    return false;
  }

  /**
   * Salva indice autocomplete per ricera
   */
  setSearchQuery(txt: string) {
    this.querySearch = txt;
    this.showAutocomplete = false;

    this.submitSearch();
    //this.keyboard.close();
  }

  /**
   * Resetta campo ricerca
   */
  resetSearch() {

    this.coreService.setWeeksBinding();

    this.showTravelEvidence = false;

    this.showAutocomplete = false;

    this.querySearch = '';
    this.autocomplete = [];
    this.manager = [];
    this.places = [];
    this.coreService.setSearchedData(null);

    this.resultsEmpty = false;
    // this.resetWeekVisible();

  }

  /**
   * Invia la ricera
   */
  submitSearch() {
    if (this.querySearch.length > 2) {
      this.showAutocomplete = false;

      this.coreService.setSearchedData(null);
      this.mantainResearch();

    } else {

      this.showTravelEvidence = false;

      this.showAutocomplete = true;
      this.autocomplete = [];
      this.manager = [];
      this.places = [];
      this.coreService.setSearchedData(null);
      this.resetWeekVisible();
    }
  }

  /**
   * Mantiene la ricera nello spostamento tra settimane
   */
  mantainResearch() {
    let findOnAutocomplete = false;
    let elementFind: string[] = [];

    let searchedData = null;
    searchedData = this.coreService.getSearchedData();

    if (searchedData) {
      this.showTravelEvidence = false;
      //ricerca settata
      // this.hideWeek();

      let type = searchedData.type;
      this.querySearch = searchedData.query;

      if (type == 0) {
        this.showTravelEvidence = false;
        this.setWeekVisible(searchedData.elements);


      } else if (type == 1) {
        this.coreService.getAutocompleteSearchValues(this.querySearch).first().subscribe(result => {
          this.showTravelEvidence = true;
          this.places = result.places;

          elementFind = [];
          let travelEvidence: any[] = [];
          if (this.places && (this.querySearch in this.places))
            for (let place of this.places[this.querySearch]) {

              let userkey = place.split('/')[3];
              let index = place.split('/')[4];

              let element_exist = false;
              for (let exist of elementFind) {
                if (exist == userkey) {
                  element_exist = true;
                  break;
                }
              }

              if (!element_exist) {
                elementFind.push(userkey);
                travelEvidence[userkey] = [index];

              } else {
                travelEvidence[userkey].push(index);
              }

              findOnAutocomplete = true;
            }


          elementFind.sort();
          travelEvidence.sort();

          this.setWeekVisible(elementFind, this.showTravelEvidence, travelEvidence);

        });
      } else if (type == 2) {

        this.coreService.getAutocompleteSearchGeneric(this.querySearch).toPromise().then(results => {
          elementFind = [];

          for (let user of results) {
            let userkey = user.split('/')[3];

            let element_exist = false;
            for (let exist of elementFind) {
              if (exist == userkey) {
                element_exist = true;
                break;
              }
            }

            if (!element_exist) {
              elementFind.push(userkey);
            }
          }

          this.showTravelEvidence = false;
          if (elementFind.length == 0) {
            this.setWeekVisible([]);
          } else {
            this.setWeekVisible(elementFind);
          }


        }).catch();

      }

    } else {

      //lanciare autocomplete per riottenere lista utenti da visualizzare con lista index per utente array
      if (this.querySearch.length > 0) {
        this.showTravelEvidence = false;
        if (this.manager[this.querySearch]) {
          //se manager taglia le prime n lettere
          let userkey = this.manager[this.querySearch].split('/')[3];
          elementFind.push(userkey);
          findOnAutocomplete = true;

          this.coreService.setSearchedData({
            type: 0,
            query: this.querySearch,
            elements: elementFind
          });

          this.setWeekVisible(elementFind);

        } else if (this.places[this.querySearch]) {
          this.showTravelEvidence = true;

          let travelEvidence: any[] = [];
          for (let place of this.places[this.querySearch]) {

            let userkey = place.split('/')[3];
            let index = place.split('/')[4];

            let element_exist = false;
            for (let exist of elementFind) {
              if (exist == userkey) {
                element_exist = true;
                break;
              }
            }

            if (!element_exist) {
              elementFind.push(userkey);
              travelEvidence[userkey] = [index];

            } else {
              travelEvidence[userkey].push(index);
            }

            findOnAutocomplete = true;
          }

          elementFind.sort();
          travelEvidence.sort();

          this.coreService.setSearchedData({
            type: 1,
            query: this.querySearch
          });

          this.setWeekVisible(elementFind, this.showTravelEvidence, travelEvidence);

        } else {

          this.coreService.getAutocompleteSearchGeneric(this.querySearch).toPromise().then(results => {

            for (let user of results) {
              let endpoint = user.split('/')[3];
              let userkey = endpoint.split('/')[0];

              let element_exist = false;
              for (let exist of elementFind) {
                if (exist == userkey) {
                  element_exist = true;
                  break;
                }
              }

              if (!element_exist) {
                elementFind.push(userkey);
              }
            }

            this.coreService.setSearchedData({
              type: 2,
              query: this.querySearch,
              elements: elementFind
            });

            if (elementFind.length == 0) {
              this.setWeekVisible([]);
            } else {
              this.setWeekVisible(elementFind);
            }
          }).catch();
        }
        //se place taglia le prime n lettere e mantiene valore key e mezza giornata se da evidenziare

      } else {

        this.resetWeekVisible();
      }

    }
  }

  /**
   * Filtra la settimana e nasconde gli utenti non desiderati
   */
  setWeekVisible(userList: string[], travelOnly: boolean = false, indexes?: any) {

    if (this.isQuerying()) {
      if (userList.length == 0)
        this.resultsEmpty = true;
      else
        this.resultsEmpty = false;
    } else {
      this.resultsEmpty = false;
    }

    if (!travelOnly) {
      for (let week of this.week_binding) {
        week.show = false;
        for (let user of userList) {
          if (user == week.user.key) {
            week.show = true;
            break;
          }
        }
      }
    } else {
      for (let week of this.week_binding) {
        week.show = false;
        for (let user of userList) {
          if (user == week.user.key) {

            for (let index of this.index_list) {
              if (indexes[user].indexOf(index) > -1) {
                week[index + '_state'] = 'Travel';
              } else {
                delete (week[index + '_state']);
              }
            }

            week.show = true;
            break;
          }
        }
      }
    }
    this.show_loading = false;
  }

  /**
   * Configura la settimana per essere visibile
   */
  resetWeekVisible() {
    this.resultsEmpty = false;

    if (this.week_binding.length > 0) {
      for (let week of this.week_binding) {
        week.show = true;
      }
      //  console.log('reset week');
      this.show_loading = false;
    }

  }

  /**
   * Nasconde la settimana per la ricerca
   */
  hideWeek() {
    for (let week of this.week_binding) {
      week.show = false;
    }
  }

  moveToNextWeek(): void {
    this.onNext = true;
    this.prevShow = true;
    this.checkNextOnce = false;
    this.showTravelEvidence = false;
    this.show_loading = true;
    this.coreService.getNextWeek();
  }

  moveToPreviousWeek(): void {
    this.onPrev = true;
    this.nextShow = true;
    this.checkPrevOnce = false;
    this.showTravelEvidence = false;
    this.show_loading = true;
    this.coreService.getPrevWeek();
  }

  /**
     * Show note se Travel
     * Verifica stato in base al testo
     */
  checkNote(txt: string): boolean {
    let showNote = true;

    if (!txt) {
      return false;
    } else if (txt.length == 0)
      return false;

    return showNote;
  }

  /**
   * Show modal Edit
   */
  showModalEdit(userkey: string, weekuser: any) {
    if (this.countSelected() > 0) {
      let profileModal = this.modalCtrl.create(ModalEditPage, { selected: this.selected_week_element, userkey: userkey, week: weekuser });

      profileModal.present();

      profileModal.onWillDismiss(end => {
        this.selected_week_element = [];
      });
    }
  }

  /**
   * Visualizza colore stato in base al valore passato
   */
  stateView(value: string, state?: string): string {
    let statusLabel = {
      "Headquarter": "headquarter",
      "Bank Holiday": "holiday",
      "Travel": "travel",
    };

    if (this.showTravelEvidence) {
      if (state)
        return statusLabel.Travel;
      else
        return statusLabel["Bank Holiday"];
    }

    if (this.onlyLeaveTravel || this.showTravelEvidence) {
      statusLabel = {
        "Headquarter": "holiday",
        "Bank Holiday": "holiday",
        "Travel": "travel",
      };
    }

    for (let i in statusLabel) {
      if (value == i) {
        return statusLabel[i];
      } else if (this.coreService.getLeaveLabel().indexOf(value) > -1) {
        return "leave";
      }
    }

    return statusLabel.Travel;

  }

  /**
     * Apre la nota nella vista leave travel sul click
     * openNote($event, '1_pm', week_days[0], 'Monday', week['1_am'], week['1_pm_note'], week.user.key)
     */
  openNote($event: any, index: string, day: string, day_text: string, halfday: string, halfday_note: string, userkey: string) {

    if (!this.onlyLeaveTravel) return; //il click funziona solo su leaveTravel

    if (legendaStati.indexOf(halfday) == -1 && this.coreService.getLeaveLabel().indexOf(halfday) == -1) {

      /*let alert = this.alertCtrl.create({
        title: txt,
        buttons: ['CLOSE']
      });
      alert.present();*/
      let half = index.split('_')[1];
      this.popover.day = day + ' ' + half.toUpperCase();

      this.popover.day_text = day_text;
      this.popover.halfday = halfday;
      this.popover.halfday_note = halfday_note;

      this.popover.userkey = userkey;
      this.popover.showEdit = false;
      this.popover.halfday_note_show = true;
      this.popover.travel = true;

      this.showPopover = true;

      //get base
      let component = document.getElementById('tooltipBase');

      if (component) {
        component.style.left = '35%';
        component.style.top = '30%';
        component.style.position = 'absolute';

        component.style.display = 'block';

        this.popover.open = true;
      }
    }
  }

  /**
   * Apre la nota dal bottone info
   */
  openNoteInfo($event: any, week: any) {

    if (this.onlyLeaveTravel) return;

    let index = this.selected_week_element[0];
    this.popover.index = index;
    let userkey = this.selected_week_userkey;

    let halfday = week[index];

    let day_of_week = index.split('_')[0];
    let half = index.split('_')[1];
    this.popover.day = this.week_days[day_of_week - 1] + ' ' + half.toUpperCase();

    let days_text = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    let index_note = index + '_note';

    this.popover.day_text = days_text[day_of_week - 1];
    this.popover.halfday = halfday;
    this.popover.halfday_note = week[index_note];

    this.popover.userkey = userkey;
    this.popover.showEdit = false;

    this.popover.week = week;

    this.popover.halfday_note_show = false;

    if (legendaStati.indexOf(halfday) == -1 && this.coreService.getLeaveLabel().indexOf(halfday) == -1) {
      this.popover.travel = true;

      if (week[index_note] && week[index_note].length > 0){
        
        this.popover.halfday_note_show = true;
      }

    } else {
      this.popover.travel = false;
    }

    this.showPopover = true;
    this.popover.showEdit = this.checkUserPermission(week.user.key) && !week.confirmed;

    //get base
    let component = document.getElementById('tooltipBase');

    if (component) {
      component.style.left = '35%';
      component.style.top = '30%';
      component.style.position = 'absolute';

      component.style.display = 'block';

      this.popover.open = true;
    }


  }

  /**
   * Chiude la nota aperta
   */
  closeNote() {
    this.showPopover = false;

    this.selected_week_element = [];
    this.selected_week_userkey = '';

    let component = document.getElementById('tooltipBase');

    component.style.display = 'none';
  }

  /**
   * Apre il modal edit direttamente dalla nota
   */
  openNoteEdit() {
    this.closeNote();

    this.selected_week_element = [this.popover.index];
    this.selected_week_userkey = this.popover.userkey;

    this.showModalEdit(this.popover.userkey, this.popover.week);
  }

  defineWeekDays(): Array<string> {

    let firstWeekDay = new Date(this.week_range[0]);
    let baseWeekDay = new Date(this.week_range[0]);

    return [
      new DatePipe("en").transform(new Date(baseWeekDay), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 1), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 2), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 3), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 4), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 5), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 6), 'd MMM y'),
    ];

    ;
  }
}



// WEBPACK FOOTER //
// ./src/pages/web-weekly-view/web-weekly-view.ts